<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-lov-select
                :value="showRow[field]"
                @input="val=>$set(showRow,field,val)"
                v-if="lv_editable"
                :lov-type="lv_lovType"
                :parent-lov-type="parentLovType"
                :parent-lov-value="parentLovValue || (!parentLovValueField?null:showRow[parentLovValueField])"
                :parent-valid-message="parentValidMessage"
                :exclude-lov="excludeLov"
                type="line"
                color="info"
                shape="none"
                :beforeSelect="!!beforeSelect?lv_beforeSelect:null"
                :afterSelect="!!afterSelect?lv_afterSelect:null"
                @change="val=>$emit('change',{val,row:showRow,rowIndex})"

                :required="lv_required"
                :rules="rules"
                :validate-on-init="validateOnInit"
            />
            <template v-else>
                <link-table-cell-normal
                    :render-func="null"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";

    import LinkLovText from "../../lov/link-lov-text";
    import LinkLovSelect from "../../lov/link-lov-select";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: "link-table-column-lov-item",
        components: { LvScopeSlot, LvColumnText, LinkLovSelect, LinkLovText},
        mixins: [ColumnItemMixin],
        props: {
            lovType: {},
            lovTypeFunc: {},
            parentLovType: {type: String},
            parentLovValue: {type: String},
            parentLovValueField: {type: String},
            parentValidMessage: {type: String},
            excludeLov: {type: Array},
            beforeSelect: {},
            afterSelect: {},
        },
        computed: {
            lv_lovType() {
                return !!this.lovTypeFunc ? this.lovTypeFunc({row: this.showRow, rowIndex: this.rowIndex}) : this.lovType
            },
        },
        methods: {
            async lv_beforeSelect(val) {
                return await this.beforeSelect({val, row: this.showRow, rowIndex: this.rowIndex, field: this.field})
            },
            async lv_afterSelect(val) {
                return await this.afterSelect({val, row: this.showRow, rowIndex: this.rowIndex, field: this.field})
            }
        }
    }
</script>
